<script setup lang="ts"></script>

<template>
  <h3>Congratulations on renewing your tariff!</h3>
</template>
